import React from 'react';
import { bool, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';

import SectionContainer from '../SectionContainer';
import css from './SectionHero.module.css';
import { NamedLink } from '../../../../components';

// Section component for a website's hero section
// The Section Hero doesn't have any Blocks by default, all the configurations are made in the Section Hero settings
const SectionHero = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    options,
    isLandingPage,
  } = props;
  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  console.log(isLandingPage, 'islandingPage');
  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={classNames(
        `${
          isLandingPage && sectionId === 'section-1'
            ? css.landingSectionRoot
            : rootClassName || css.root
        } `
      )}
      appearance={appearance}
      options={fieldOptions}
    >
      {' '}
      {isLandingPage && sectionId === 'section-1' ? (
        <>
          <Field
            data={title}
            className={css.landingPagetitle}
            options={fieldOptions}
            style={sectionId === 'section-1' ? { color: '#fff' } : {}}
          />
          <p className={css.landingPageText}>
            Your journey into exceptional preloved South Asian fashion starts here.
          </p>
          <div className={css.buttons}>
            <NamedLink name="SelectCategoryPage" className={css.button}>
              <span>Sell Now</span>
            </NamedLink>
            <NamedLink name="ShopUsPage" className={css.button}>
              <span>Shop Now</span>
            </NamedLink>
          </div>
        </>
      ) : hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field
            data={title}
            className={css.title}
            options={fieldOptions}
            style={sectionId === 'section-1' ? { color: '#F2684B' } : {}}
          />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
        </header>
      ) : null}
      {/* {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field
            data={title}
            className={css.title}
            options={fieldOptions}
            style={sectionId === 'section-1' ? { color: '#F2684B' } : {}}
          />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
        </header>
      ) : null} */}
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionHero.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  isInsideContainer: false,
  options: null,
};

SectionHero.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionHero;
